import { useState } from "react";
import { useLenis } from "lenis/react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Servizi", href: "#servizi", id: "servizi" },
  { label: "Metodo UV", href: "#metodo-uv", id: "metodo-uv" },
  { label: "Laser", href: "#laser", id: "laser" },
  { label: "Filosofia", href: "#filosofia", id: "filosofia" },
  { label: "Galleria", href: "#galleria", id: "galleria" },
  { label: "Recensioni", href: "#recensioni", id: "recensioni" },
];

export default function Header() {
  const lenis = useLenis();
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    lenis?.scrollTo(href, { offset: -72, duration: 1.6 });
  };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 border-b border-blush-100 bg-cream/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="logo-link"
          className="flex items-baseline gap-2"
        >
          <span className="font-serif text-2xl italic leading-none text-ink">
            Lash Queen
          </span>
          <span className="text-[10px] font-semibold uppercase tracking-[0.35em] text-blush-500">
            Carpi
          </span>
        </a>

        <nav className="hidden items-center gap-10 lg:flex" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.id}`}
              className="group relative text-xs font-medium uppercase tracking-[0.25em] text-ink-soft transition-colors duration-300 hover:text-ink"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-blush-500 transition-[width] duration-500 group-hover:w-full" />
            </a>
          ))}
          <a
            href="#prenota"
            onClick={(e) => go(e, "#prenota")}
            data-testid="nav-cta-prenota"
            className="rounded-full bg-ink px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.25em] text-blush-50 transition-colors duration-300 hover:bg-blush-600"
          >
            Prenota
          </a>
        </nav>

        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="text-ink lg:hidden"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-nav"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-blush-100 bg-cream/95 backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col gap-6 px-6 py-8">
              {LINKS.map((l) => (
                <a
                  key={l.id}
                  href={l.href}
                  onClick={(e) => go(e, l.href)}
                  data-testid={`mobile-nav-link-${l.id}`}
                  className="font-serif text-3xl italic text-ink"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#prenota"
                onClick={(e) => go(e, "#prenota")}
                data-testid="mobile-nav-cta-prenota"
                className="mt-2 w-fit rounded-full bg-ink px-8 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-blush-50"
              >
                Prenota
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
